export const ContractTypes = {
  NO_CONTRACT: "NOCONT",
  ONE_SERVICE: "ONE",
  ONE_SERVICE_ONE_INSPECTION: "ONEINS",
  TWO_SERVICES: "TWO",
  TWO_SERVICES_TWO_INSPECTIONS: "TWOINS"
};

export const InventoryTypes = {
  CELLAR_LIFT: "CELL",
  VEHICLE_LIFT: "SWING",
  LOWERING_SYSTEM: "RANDL"
};

export const JobTypes = {
    SERVICE: "SERVIC",
    INSPECTION: "INSPEC",
    INSTALL_COMMISSION: "COMM"
};

export const ServiceProducts = {    
  PRODUCT_CELLAR_LIFT: "CL",
  PRODUCT_MEZZ_LIFT_250: "MEZZ",
  PRODUCT_MEZZ_LIFT_500: "MEZZ 500",  
  PRODUCT_STILLAGE_TRUCK: "KAYEL"
};

export const ServiceCharges = {
  VEHICLE_LIFT_SERVICE_CHARGE: "SLS1",
  VEHICLE_LIFT_INSPECTION_CHARGE: "SLI1",
  MEZZ_LIFT_250_SERVICE_CHARGE: "LS",
  MEZZ_LIFT_250_INSPECTION_CHARGE: "LI",
  MEZZ_LIFT_500_SERVICE_CHARGE: "LS500",
  MEZZ_LIFT_500_INSPECTION_CHARGE: "LI500",
  FORKLIFT_SERVICE_CHARGE: "FLS"
};

const Constants = {
  ServiceCharges,
  InventoryTypes,
  ContractTypes
};

export default Constants;
